import React, { FC, ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import InitialConfigFormFields from '../../models/InitialConfigFormFields';
import ConnectForm from '../../../../common/reactHookForm/ConnectForm';
import { HelperTextInputField } from '@thingslog/ui-components';

const OnOffAutoConfig: FC<OnOffAutoConfigProps> = ({ index }: OnOffAutoConfigProps) => {
  const { t } = useTranslation();

  return (
    <ConnectForm<InitialConfigFormFields>>
      {({ register }: UseFormReturn<InitialConfigFormFields>): ReactElement => (
        <>
          <HelperTextInputField
            {...register(`ports.${index}.sensor.groupName`)}
            label={t('groupName')}
            size="small"
          />
        </>
      )}
    </ConnectForm>
  );
};

interface OnOffAutoConfigProps {
  index: number;
}

export default OnOffAutoConfig;
